<template>
  <svg width="20"
       height="20"
       viewBox="0 0 20 20"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17.5 4.98332C14.725 4.70832 11.9333 4.56665 9.15 4.56665C7.5 4.56665 5.85 4.64998 4.2 4.81665L2.5 4.98332"
          stroke="#595A5B"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
    />
    <path
      d="M7.08333 4.14169L7.26666 3.05002C7.4 2.25835 7.49999 1.66669 8.90833 1.66669H11.0917C12.5 1.66669 12.6083 2.29169 12.7333 3.05835L12.9167 4.14169"
      stroke="#595A5B"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.7084 7.6167L15.1667 16.0084C15.075 17.3167 15 18.3334 12.675 18.3334H7.32502C5.00002 18.3334 4.92502 17.3167 4.83335 16.0084L4.29169 7.6167"
      stroke="#595A5B"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M8.60829 13.75H11.3833"
          stroke="#595A5B"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
    />
    <path d="M7.91667 10.4167H12.0833"
          stroke="#595A5B"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
    />
  </svg>
</template>
